module.exports = __webpack_public_path__ + "media/12_28.699c5d00.wav";